<template>
  <th v-if="isHeader">
    {{'Actions' | trans}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button v-if="!isSelected" class="btn btn-sm btn-primary" @click="addToReport(rowData)">
        <i class="icons icon-plus"></i>&nbsp;{{'Add' | translate }}
      </button>
      <button v-else class="btn btn-sm btn-success" @click="removeFromReport(rowData)">
        <i class="icons icon-check"></i>&nbsp;{{'Added' | translate }}
      </button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isSelected: function () {
      return this.$store.getters.isJointInNewReport(this.rowData.joint_id)
    }
  },
  methods: {
    addToReport: function (data) {
      this.$store.commit('addJointToNewReport', data)
    },
    removeFromReport: function (data) {
      this.$store.commit('removeJointFromNewReport', data.joint_id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// VueTableNewReportActions.vue?63d38ac0